export default __webpack_public_path__ + "static/media/1.dd5072ab.jpg";